import { render } from "./UofMConversationsWMaryJo.vue?vue&type=template&id=f150c646&scoped=true"
import script from "./UofMConversationsWMaryJo.vue?vue&type=script&lang=js"
export * from "./UofMConversationsWMaryJo.vue?vue&type=script&lang=js"

import "./UofMConversationsWMaryJo.vue?vue&type=style&index=0&id=f150c646&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f150c646"]])

export default __exports__